import React from 'react';
import { Route, Switch } from 'react-router-dom';

import WhatToExpectPage from '../WhatToExpectPage/WhatToExpectPage';

import SkillsPage from './SkillsPage/SkillsPage';
import CatCareDetailsPage from './CatCareDetailsPage';
import DogCareDetailsPage from './DogCareDetailsPage';
import SitterProfileContent from './SitterProfileContent';

const SitterProfilePage: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/provider-profile/details/dog-care-details">
        <DogCareDetailsPage />
      </Route>
      <Route exact path="/provider-profile/details/cat-care-details">
        <CatCareDetailsPage />
      </Route>
      <Route exact path="/provider-profile/details/skills">
        <SkillsPage />
      </Route>
      <Route exact path="/provider-profile/details/what-to-expect">
        <WhatToExpectPage />
      </Route>
      <Route exact path="/provider-profile/details">
        <SitterProfileContent />
      </Route>

      {/* Existing Provider Sign-Up (EPSU) routes */}
      <Route
        exact
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/dog-care-details"
      >
        <DogCareDetailsPage />
      </Route>
      <Route
        exact
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/cat-care-details"
      >
        <CatCareDetailsPage />
      </Route>
      <Route exact path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/skills">
        <SkillsPage />
      </Route>
      <Route
        exact
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/what-to-expect"
      >
        <WhatToExpectPage />
      </Route>
      <Route exact path="/provider-profile/existing-provider-sign-up/:serviceSlug/details">
        <SitterProfileContent />
      </Route>
    </Switch>
  );
};

export default SitterProfilePage;
